/**
 * Status da cobrança na Omie. Separado do badge porque a exportação CSV precisa do mesmo
 * rótulo sem renderizar componente — e duplicar o mapa faria a planilha e a tela divergirem
 * na primeira mudança de vocabulário.
 */
export const INVOICE_STATUS_CONFIG: Record<
  string,
  { label: string; variant: 'primary' | 'warning' | 'success' | 'destructive' | 'secondary' }
> = {
  'A VENCER':   { label: 'A vencer',   variant: 'primary' },
  'VENCE HOJE': { label: 'Vence hoje', variant: 'warning' },
  'RECEBIDO':   { label: 'Recebido',   variant: 'success' },
  'ATRASADO':   { label: 'Atrasado',   variant: 'warning' },
  'CANCELADO':  { label: 'Cancelado',  variant: 'destructive' },
};

export const DEFAULT_INVOICE_STATUS = INVOICE_STATUS_CONFIG['A VENCER'];

export function invoiceStatusLabel(status: string): string {
  return INVOICE_STATUS_CONFIG[status]?.label ?? status;
}
